import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/swiper-bundle.min.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

var swiper1 = new Swiper(".list1 .mySwiper", {
  autoHeight: true,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{  
    init: function(swiper){
      $('.list1 .swiper-tab div').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.list1 .swiper-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})
$('.list1 .swiper-tab div').hover(function(){
  let index = $(this).index()
  swiper1.slideTo(index)
})

var swiper2 = new Swiper(".list2 .mySwiper", {
  autoHeight: true,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{  
    init: function(swiper){
      $('.list2 .swiper-tab div').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.list2 .swiper-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})
$('.list2 .swiper-tab div').hover(function(){
  let index = $(this).index()
  swiper2.slideTo(index)
})

var swiper3 = new Swiper(".list3 .mySwiper", {
  autoHeight: true,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{  
    init: function(swiper){
      $('.list3 .swiper-tab div').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.list3 .swiper-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})
$('.list3 .swiper-tab div').hover(function(){
  let index = $(this).index()
  swiper3.slideTo(index)
})

var swiper4 = new Swiper(".list4 .mySwiper", {
  autoHeight: true,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{  
    init: function(swiper){
      $('.list4 .swiper-tab div').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.list4 .swiper-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})
$('.list4 .swiper-tab div').hover(function(){
  let index = $(this).index()
  swiper4.slideTo(index)
})

var swiper5 = new Swiper(".list5 .mySwiper", {
  autoHeight: true,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{  
    init: function(swiper){
      $('.list5 .swiper-tab div').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.list5 .swiper-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})
$('.list5 .swiper-tab div').hover(function(){
  let index = $(this).index()
  swiper5.slideTo(index)
})